import styled from "styled-components";
import { FoxCommonCardListWrapper, beforeCss } from "../../atom";

export const FoxGiftCouponWrapper = styled.div`
  .card-list-wrapper {
    overflow: hidden;
  }
`;
export const CardListContent = styled.div`
  position: relative;
  .scroll-button {
    position: absolute;
    cursor: pointer;
    top: 0;
    bottom: 0;
    margin: auto 0;
    z-index: 10;
  }

  .left-button {
    left: -30px;
  }

  .right-button {
    right: -30px;
  }
`;
export const FoxGiftCouponCardList = styled(FoxCommonCardListWrapper)`
  width: max-content;
  padding-right: 10px;
`;

export const FoxGiftCouponCard = styled.div<{ isActive: boolean }>`
  position: relative;
  width: 224px;
  height: 134px;
  box-shadow: inset 0 0 0 1px rgba(73, 83, 89, 1);
  background: ${(p) => (p.isActive ? "rgba(243, 81, 43, 0.04)" : "#292b2f")};
  border-radius: 8px;
  padding: 16px 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  gap: 8px;
  ${(p) => p.isActive && beforeCss};
  .recharge-price {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    height: 42px;
    line-height: 42px;
    width: 100%;
    .price {
      font-size: 30px;
      font-weight: 500;
    }
  }
  .extra-welfare {
    .tip-text {
      color: ${(p) => (p.isActive ? "#F3512B" : "#FFFFFF")};
      height: 20px;
      width: 100%;
      margin-bottom: 6px;
      font-size: 12px;
    }
    .gift-amount {
      padding: 0 8px;
      font-size: 14px;
      line-height: 26px;
      color: #ffffff;
      background: ${(p) =>
        p.isActive ? "rgba(243, 81, 43, 0.15)" : "rgba(255, 255, 255, 0.06)"};
      border-radius: 20px;
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 6px;
      svg {
        margin-right: 6px;
        fill: ${(p) => (p.isActive ? "#F3512B" : "#727E84")};
      }
    }
  }
  :hover {
    background: rgba(243, 81, 43, 0.04);
    ${beforeCss};
    .extra-welfare {
      .tip-text {
        color: #f3512b;
      }
      .gift-amount {
        background: rgba(243, 81, 43, 0.15);
        svg {
          fill: #f3512b;
        }
      }
    }
  }
`;
